export default "__VITE_ASSET__HkeVrC1Z__"